import { font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

export const BrandAnimationLayout = styled.div`
  background-color: ${themedColor('white')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

export const BrandPriceCompressionTitle = styled.p`
  ${MEDIA_QUERIES.desktop`
        ${font('alt', { fontSize: '2rem', lineHeight: '1.5', fontWeight: 400 })};
    `}

  ${MEDIA_QUERIES.upToDesktop`
        ${font('alt', { fontSize: '1.8rem', lineHeight: '1.5', fontWeight: 400 })};
    `}
`;
